import type { MechKey } from './keys';

export const pl: Partial<Record<MechKey, string>> = {
  'app.eyebrow': 'Mechanika · 2D',
  'panel.scene': 'Scena',
  'panel.dims': 'Parametry',
  'panel.style': 'Wygląd',
  'panel.action': 'Sterowanie',
  'style.body': 'Ciało',
  'style.vector': 'Wektory',
  'style.ground': 'Podłoże',
  'style.forces': 'Pokaż siły',
  'style.trace': 'Pokaż ślad',
  'style.labels': 'Etykiety wektorów',
  'hint.line1': 'Kliknij odtwórz, aby rozpocząć · przeciągaj ciała, aby je przesuwać',
  'hint.line2': 'Sandbox: wybierz kształt, a następnie kliknij, aby go umieścić',
  'scene.incline': 'Równia pochyła',
  'scene.projectile': 'Ruch rzutu ukośnego',
  'scene.pendulum': 'Wahadło',
  'scene.springMass': 'Układ masa-sprężyna',
  'scene.collisions': 'Zderzenia',
  'scene.atwood': 'Maszyna Atwooda',
  'scene.circular': 'Ruch po okręgu',
  'scene.sandbox': 'Sandbox',
  'dim.angle': 'kąt (°)',
  'dim.friction': 'tarcie',
  'dim.mass': 'masa',
  'dim.massA': 'masa A',
  'dim.massB': 'masa B',
  'dim.velocity': 'prędkość',
  'dim.angleLaunch': 'kąt wyrzutu (°)',
  'dim.gravity': 'grawitacja',
  'dim.gravityX': 'grawitacja x',
  'dim.gravityY': 'grawitacja y',
  'dim.length': 'długość',
  'dim.damping': 'tłumienie',
  'dim.spring': 'sztywność',
  'dim.restitution': 'restytucja',
  'dim.radius': 'promień',
  'dim.speed': 'szybkość',
  'action.play': 'Odtwórz',
  'action.pause': 'Pauza',
  'action.step': 'Krok',
  'action.reset': 'Resetuj',
  'action.speed': 'Prędkość',
  'action.clear': 'Wyczyść',
  'force.gravity': 'Fg',
  'force.normal': 'N',
  'force.friction': 'Ff',
  'force.tension': 'T',
  'force.spring': 'Fs',
  'force.applied': 'Fa',
  'force.air': 'Fd',
  'forceName.gravity': 'Grawitacja',
  'forceName.normal': 'Reakcja normalna',
  'forceName.friction': 'Tarcie',
  'forceName.tension': 'Napięcie',
  'forceName.spring': 'Siła sprężyny',
  'forceName.applied': 'Siła przyłożona',
  'forceName.air': 'Opór powietrza',
  'palette.box': 'Sześcian',
  'palette.circle': 'Piłka',
  'palette.ramp': 'Pochylnia',
  'palette.ground': 'Podłoże',
  'palette.hint': 'Wybierz kształt, a następnie kliknij na płótno, aby go umieścić.',
  'panel.forces': 'Zaobserwowane siły',
  'forces.empty': 'Brak — odtwórz scenę',
};
